import { routerPostCall } from '../../axios';

const uploadPolicyAsset = (state, params) => {
    const { policyNumber, name, description, file } = params;
    // `file` is a blob URL string returned by the CMS upload step
    return routerPostCall(
        state,
        `/accounts/policies/${encodeURIComponent(policyNumber)}/assets`,
        { name, description, file },
    );
};

export default { uploadPolicyAsset };
